import { makeRequest } from './data_utils';

const getLatestLLMLogs = () => {
    const endpoint = `api/llm-logs/latest`;
    return makeRequest(endpoint, 'GET');
};

const getSearchLLMLogs = (instance_id, short_id) => {
    let endpoint = `api/llm-logs/search`;
    if (instance_id) {
        endpoint += `?instance_id=${instance_id}`;
    } else if (short_id) {
        endpoint += `?short_id=${short_id}`;
    }
    return makeRequest(endpoint, 'GET');
};

const rerunLLMQuery = (instance_id, connection_id, prompt, system_prompt, structure, type, ref_name, ref_value) => {
    let endpoint = `api/llm-logs/rerun`;
    const body = {
        instance_id: instance_id,
        connection_id: connection_id,
        prompt: prompt,
        system_prompt: system_prompt,
        structure: structure,
        type: type,
        ref_name: ref_name,
        ref_value: ref_value
    }
    return makeRequest(endpoint, 'POST', body);
};


export const llmLogsData = {
    getLatestLLMLogs,
    getSearchLLMLogs,
    rerunLLMQuery
};
